import { addDays, isSameDay, startOfWeek } from "date-fns";
import { ChevronLeft, ChevronRight } from "lucide-react";

const DAY = ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"];
const MON = ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"];

export const DayStrip = ({ selectedDate, onSelect, countFor }) => {
  const start = startOfWeek(selectedDate, { weekStartsOn: 1 });
  const days = Array.from({ length: 7 }, (_, i) => addDays(start, i));
  const today = new Date();
  const Arrow = ({ dir, Icon }) => (
    <button type="button" onClick={() => onSelect(addDays(selectedDate, dir * 7))}
      className="shrink-0 w-9 rounded-xl text-[#1F2A44] hover:bg-stone-100 transition-colors flex items-center justify-center"
      data-testid={`day-strip-${dir < 0 ? "prev" : "next"}-week`} aria-label={dir < 0 ? "Önceki hafta" : "Sonraki hafta"}>
      <Icon className="w-4 h-4" />
    </button>
  );
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-stone-200 p-2 flex gap-1.5 overflow-x-auto" data-testid="day-strip">
      <Arrow dir={-1} Icon={ChevronLeft} />
      {days.map((d) => {
        const on = isSameDay(d, selectedDate);
        const isToday = isSameDay(d, today);
        const n = countFor ? countFor(d) : 0;
        return (
          <button key={d.toISOString()} type="button" onClick={() => onSelect(d)}
            className={`relative flex-1 shrink-0 rounded-xl px-2 py-2 text-center min-w-[64px] transition-colors ${on ? "bg-emerald-600 text-white" : isToday ? "ring-1 ring-inset ring-emerald-500 text-emerald-700 hover:bg-emerald-50" : "hover:bg-stone-100 text-[#1F2A44]"}`}
            data-testid={`day-strip-${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`}>
            <p className="text-[11px] opacity-80">{DAY[d.getDay()]}</p>
            <p className="text-lg font-bold leading-tight" style={{ fontFamily: "Manrope" }}>{d.getDate()}</p>
            <p className="text-[10px] opacity-80">{MON[d.getMonth()]}</p>
            {n > 0 && (
              <span className={`absolute top-1 right-1 min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold flex items-center justify-center ${on ? "bg-white text-emerald-700" : "bg-emerald-100 text-emerald-800"}`}>{n}</span>
            )}
          </button>
        );
      })}
      <Arrow dir={1} Icon={ChevronRight} />
    </div>
  );
};
